import axios from 'axios';
import authHeader from './auth-header';

class RoleDataService {
  // getAll() {
  //   return axios.get(API_URL + "competitions", { headers: authHeader() });
  // }

  // getAllCallroom() {
  //   return axios.get(API_URL + "callroomCompetitions", { headers: authHeader() });
  // }

  // get(id) {
  //   return axios.get(API_URL + `competition/${id}`, { headers: authHeader() });
  // }

  // getFull(id) {
  //   return axios.get(API_URL + `competitionFull/${id}`, { headers: authHeader() });
  // }

  create(data) {
    console.log(data);
    return axios.post(`/api/competition/${data.competition_id}/admin/add`, data, { headers: authHeader() });
  }

  // update(id, data) {
  //   return axios.put(`/api/competition/${id}`, data, { headers: authHeader() });
  // }

  // delete(id) {
  //   return axios.delete(`/api/competition/${id}`, { headers: authHeader() });
  // }

  // deleteAll() {
  //   return http.delete(`/api/competitions`);
  // }

  // findByTitle(title) {
  //   return http.get(`/api/competitions?title=${title}`);
  // }

}

export default new RoleDataService();

